var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71429 2.28516C4.76749 2.28516 4 3.05264 4 3.99944C4 4.94624 4.76749 5.71373 5.71429 5.71373C6.66109 5.71373 7.42857 4.94624 7.42857 3.99944C7.42857 3.05264 6.66109 2.28516 5.71429 2.28516ZM5.14286 3.99944C5.14286 3.68384 5.39869 3.42801 5.71429 3.42801C6.02989 3.42801 6.28571 3.68384 6.28571 3.99944C6.28571 4.31504 6.02989 4.57087 5.71429 4.57087C5.39869 4.57087 5.14286 4.31504 5.14286 3.99944Z",
    fill: "#0A7F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3314 3.58897C10.024 1.22963 7.89269 0 5.71429 0C3.53587 0 1.40455 1.22963 0.0971605 3.58897C-0.0306452 3.81966 -0.0322224 4.10406 0.0915947 4.33577C1.37819 6.7436 3.5216 8 5.71429 8C7.90697 8 10.0504 6.7436 11.337 4.33577C11.4608 4.10406 11.4592 3.81966 11.3314 3.58897ZM5.71429 6.85714C4.03484 6.85714 2.30887 5.92709 1.19527 3.97069C2.32493 2.05494 4.04182 1.14286 5.71429 1.14286C7.38674 1.14286 9.10366 2.05494 10.2333 3.97069C9.11971 5.92709 7.39371 6.85714 5.71429 6.85714Z",
    fill: "#0A7F8F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewActive);
export default __webpack_public_path__ + "static/media/view_active.17e950045f5f5b53be54afcede035976.svg";
export { ForwardRef as ReactComponent };